import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const StarIcon = (props: SvgProps) => (
  <Svg
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="m3.548 12.363.918-3.929L1.418 5.8l4.013-.35L7 1.75l1.576 3.7 4.005.35-3.049 2.634.925 3.929-3.455-2.088-3.455 2.088Z"
    />
  </Svg>
)
export default StarIcon
